// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge__f2Dog","counter":"counter__bFA2n"};